import React from 'react';

// Fonction utilitaire pour remplacer les mots avec des spans stylisés
export const formatText = (text, replacements) => {
    if (!text) return text;

    let formattedText = text;
    
    replacements.forEach(({ words, className, symbol }) => {
        const regex = new RegExp(`\\b(${words.join('|')})\\b`, 'g');
        formattedText = formattedText.replace(regex, (match) => {
            if (symbol) {
                const symbolForWord = symbol[match] || '';
                return `<span class="${className}">${match}<span class="astro-symbol">${symbolForWord}</span></span>`;
            }
            return `<span class="${className}">${match}</span>`;
        });
    });

    return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
};

export const FormatText = ({ children, replacements }) => {
    const formatContent = (content) => {
        if (typeof content !== 'string') return content;

        let formattedContent = content;
        replacements.forEach(({ words, className, symbol, useRegex }) => {
            // Pattern modifié pour ne pas capturer "en"
            const pattern = useRegex ? 
                '(?:[Mm]aison\\s*(\\d+)|(?<=en maison\\s*)\\d+)' :
                `\\b(${words.join('|')})\\b`;

            const regex = new RegExp(pattern, 'gi');
            formattedContent = formattedContent.replace(regex, (match, ...groups) => {
                // Cas spécial pour les maisons
                if (useRegex) {
                    const num = match.match(/\d+/)[0];
                    return `<span class="maison${num}-text">${match}</span>`;
                }
                
                // Cas normal avec symboles
                if (symbol && symbol[match]) {
                    return `<span class="${className}">${match}<span class="astro-symbol ${match.toLowerCase()}-symbol">${symbol[match]}</span></span>`;
                }
                
                // Cas normal sans symbole
                return `<span class="${match.toLowerCase()}-text">${match}</span>`;
            });
        });

        return formattedContent === content ? 
            content : 
            <span dangerouslySetInnerHTML={{ __html: formattedContent }} />;
    };

    const processChildren = (children) => {
        return React.Children.map(children, child => {
            if (!child) return child;
            if (typeof child === 'string') {
                return formatContent(child);
            }
            if (React.isValidElement(child)) {
                const childProps = { ...child.props };
                if (child.props.children) {
                    childProps.children = processChildren(child.props.children);
                }
                return React.cloneElement(child, childProps);
            }
            return child;
        });
    };

    return <>{processChildren(children)}</>;
}; 